import { onError } from 'apollo-link-error'
import { log } from '@sketch/utils'

import store from 'redux/store'
import { actions as toastActions } from '@sketch/toasts/redux'

import { debouncedLogoutActiveSession } from 'graphql/utils'
import ApolloClient from 'apollo-client'
import { NormalizedCacheObject } from 'apollo-cache-inmemory'
import type { History } from 'history'

const FORCE_LOGOUT_REASONS = [
  'ACCESS_TOKEN_EXPIRED',
  'USER_NOT_LOGGED_IN',
  'INVALID_ACCESS_TOKEN',
  'TOKEN_EXPIRED',
  'NO_TOKEN',
  'TOKEN_INVALID',
  'TOKEN_MALFORMED',
  'USER_NOT_SKETCH_CLIENT',
]

// Some queries return the "UNAUTHORIZED" error-code but we want to prevent the logout action.
// see https://github.com/sketch-hq/Cloud/issues/3085 as example
const FORCE_LOGOUT_IGNORE_OPERATIONS = ['getRedemption', 'getInitialUser']

// TODO: move this to `user`, `sso` or a new `auth` module.
// Also, rename this module to say what it does, not on which action it reacts.
// see: https://github.com/sketch-hq/Cloud/issues/15957
export const createOnErrorLink = (
  getClient: () => ApolloClient<NormalizedCacheObject>,
  history: History
) =>
  onError(({ graphQLErrors, networkError, operation }) => {
    if (Array.isArray(graphQLErrors)) {
      if (graphQLErrors.includes('invalid_token')) {
        debouncedLogoutActiveSession(
          getClient(),
          history,
          operation.operationName,
          'invalid_token'
        )
      }

      graphQLErrors.forEach(({ message, locations, path, extensions }) => {
        const code = extensions?.code ?? 'none'
        const reason = extensions?.reason ?? 'none'
        log(`operation name: ${operation.operationName}`)
        log(
          `[GraphQL error]: Message: ${message}, Code: ${code} Location: ${locations},
          Path: ${path}`
        )

        if (
          code === 'UNAUTHORIZED' &&
          FORCE_LOGOUT_REASONS.includes(reason) &&
          !FORCE_LOGOUT_IGNORE_OPERATIONS.includes(operation.operationName)
        ) {
          debouncedLogoutActiveSession(
            getClient(),
            history,
            operation.operationName,
            message,
            reason
          )
        }
      })
    }
    if (networkError) {
      if (!navigator.onLine) {
        store.dispatch(
          toastActions.add({
            message:
              'You appear to be offline. Please check your internet connection and try again.',
            variant: 'negative',
          })
        )
      }
      log(`operation name: ${operation.operationName}`)
      log(`[Network error]: ${networkError}`)
    }
  })
